import React from "react"
import "./FourPartPage.css";


import {
    Button,
    Grid,
    H2,
    Paragraph,
    OnPageNavigation,
    Picture,
    Section,
    Stage,
    Spinner,
    Theme, Headline, GallerySlider, Layer, Video, Link
} from "@lsg/components";
import {connect} from "react-redux";
import {Page} from "../Page/Page";
import PersonCard from "../../components/PersonCard";
import BookmarkCountdown from "../../components/BookmarkCountdown";

let navigationTree;
navigationTree = [
    {
        name: "item-1",
        label: "Info",
        targetId: "section-1",
    },
    {
        name: "item-2",
        label:"Agenda",
        targetId:"agenda",
    },
    {
        name: "item-3",
        label: "Speakers",
        targetId: "section-2",
    },
    {
        name: "item-4",
        label: "Partners",
        targetId: "section-3",
    },
    {
        name: "item-5",
        label: "2025 Throwback",
        targetId: "section-4",
    },
    {
        name: "item-6",
        label: "TechConnect Team",
        targetId: "section-5",
    }
];

const stage1Agenda = [
    {
        title: "Grand Opening",
        time: "09:00 - 09:30",
        details: {
            speakers: [
                "Adam Pustelnik",
                "Dominik Stöttner",
                "PhD Marek Gajowniczek"
            ],
            moderator: null
        },
        abstract: ""
    },
    {
        title: "Will Innovation Take Away Our Joy?",
        time: "09:30 - 09:45",
        details: {
            speakers: [
                "Grzegorz Sztandera, Commerzbank"
            ],
            moderator: null
        },
        abstract: "Artificial intelligence could effectively replace the joy of work with mechanical, repetitive verification of model outputs. Imagine a developer - a classic poet of code, a virtuoso in his craft. And suddenly, AI takes over coding. What does that developer become then?"
    },
    {
        title: "Tomorrow Starts Today: The Future Won't Reward What We Know. So What Will Matter?",
        time: "09:45 - 10:15",
        details: {
            speakers: [
                "Karolina Brzozowska",
                "Małgorzata Kapral"
            ],
            moderator: null
        },
        abstract: "Every technological revolution changed how we work. This one is changing who we need to become.\n" +
            "As AI puts intelligence into everyone's hands, the true differentiator is shifting from what we know to how we adapt, communicate, lead, create meaning and collaborate across increasing complexity.\n" +
            "Let's explore why the future of work is becoming deeply human and what individuals and organizations must do today to navigate what comes next and thrive in an AI-driven world."
    },
    {
        title: "Discussion Panel: The Canvas of Skills - How Do We Prepare Today's Workforce for AI-Driven Business?",
        time: "10:15 - 11:00",
        details: {
            speakers: [
                "Edyta Sikorska",
                "Alessandra Dolfetti",
                "Karolina Bioch-Spicola",
                "Aleksandra Grzelak",
                "Łukasz Belica"
            ],
            moderator: "Barbara Michalak"
        },
        abstract: "During this discussion panel the accomplished leaders from HR and Business will explore how organizations can equip employees with the capabilities needed in an AI-powered world. The panel will examine the evolving mix of technical, analytical, and human skills, the role of continuous learning, and how leaders can foster adaptability and responsible AI usage. Bringing together industry experts, the discussion will highlight practical approaches to reskilling, redefining roles, and building a workforce that can collaborate effectively with AI while maintaining critical thinking, creativity, and accountability."
    },
    {
        title: "Coffee Break",
        time: "11:00 - 11:30",
        details: {
            speakers: [],
            moderator: null
        },
        abstract: ""
    },
    {
        title: "Microsoft Keynote: The Art of the Frontier Firm",
        time: "11:30 - 12:00",
        details: {
            speakers: [
                "Michał Furmankiewicz, Microsoft"
            ],
            moderator: null
        },
        abstract: "Across every industry, AI is moving from isolated experiments to a core operating capability - what Microsoft calls the Frontier Firm. In this 30-minute keynote, Microsoft shares what separates organisations that scale AI from those that stall after their first wins, drawing on lessons from Fortune 500 adopters and from Microsoft's own journey as Customer Zero. The session explores two ingredients that consistently turn AI from a project into a competitive advantage: Intelligence and Trust."
    },
    {
        title: "Discussion Panel: The Portrait of Banking: How Can AI Transform Banking Operations and Customer Experience in the Future?",
        time: "12:00 - 13:00",
        details: {
            speakers: [
                "Dominik Stöttner",
                "Robert Buda",
                "Agnieszka Belowska-Gosławska",
                "Sandra Flavia Fensterseifer",
                "Przemysław Koper"
            ],
            moderator: "Agata Słubik"
        },
        abstract: "The panel explores how AI is reshaping banking operations and customer experience, with practical insights on scaling AI while balancing innovation, trust, resilience, and regulatory expectations."
    },
    {
        title: "Lunch Break",
        time: "13:00 - 14-00",
        details: {
            speakers: [],
            moderator: null
        },
        abstract: ""
    },
    {
        title: "Stablecoins, Digital Euro and Tokenization -> Blockchain in European Banking",
        time: "14:00 - 14:30",
        details: {
            speakers: [
                "Dominik Zyskowski, Espeo"
            ],
            moderator: null
        },
        abstract: "The presentation outlines three pillars likely to shape Europe's financial infrastructure over the next 2-3 years: stablecoins and tokenized deposits, digital euro or wholesale CBDC, and asset tokenization."
    },
    {
        title: "Quantum Computing and the Future of Banking: From Security Risks to Quantum Resilience and New Opportunities!",
        time: "14:30 - 15:00",
        details: {
            speakers: [
                "PhD Mirosław Sopek, Makolab"
            ],
            moderator: null
        },
        abstract: "PhD Mirosław Sopek, CEO of MakoLab, will present an insightful perspective on the future of banking in the era of quantum computing. The session will explore how emerging quantum technologies may disrupt existing cryptographic standards, creating new security challenges for financial institutions. At the same time, it will highlight the opportunities quantum computing brings in areas such as advanced data processing, optimization, and risk modeling. The presentation will also address the concept of quantum resilience, including the adoption of post-quantum cryptography, and outline how forward-thinking banks can proactively prepare for and capitalize on this technological shift.\n" + "\n" + "Participants will gain a clear understanding of quantum-related risks to financial security, an overview of practical approaches to achieving quantum resilience, and insights into how quantum computing can create new business and innovation opportunities in banking."
    },
    {
        title: "Discussion Panel: The Moral Palette: How Do We Balance Rapid Technology Growth with Corporate Accountability?",
        time: "15:00 - 15:45",
        details: {
            speakers: [
                "Bartłomiej Szymański",
                "PhD Magdalena Wróbel-Lachowska",
                "Igor Savic",
                "PhD Marek Gajowniczek",
                "Prof. Dominika Kaczorowska-Spychalska"
            ],
            moderator: "Aleksandra Kaźmierczak"
        },
        abstract: "The panel discusses how to balance rapid technological growth with ethics, governance, transparency, and corporate accountability in AI-driven transformation."
    },
    {
        title: "Banking of Tomorrow: Between Trust and Algorithms",
        time: "15:45 - 16:15",
        details: {
            speakers: [
                "Ariel Zgórski, ING"
            ],
            moderator: null
        },
        abstract: "The session presents key AI innovations in banking and explains how trust, transparency, and security must evolve alongside increasingly autonomous decision-making systems."
    },
    {
        title: "Thank You to Patrons & Partners",
        time: "16:15 - 16-30",
        details: {
            speakers: [],
            moderator: null
        },
        abstract: ""
    },
    {
        title: "Closing Speech",
        time: "16:30 - 17:00",
        details: {
            speakers: [
                "Marek Gajowniczek, Commerzbank"
            ],
            moderator: null
        },
        abstract: ""
    }
];

const stage2Agenda = [
    {
        title: "Splitting LLMs Across Serverless GPUs: The Project That Won an International Google Hackathon",
        time: "09:30 - 10:00",
        details: {
            speakers: [
                "Michał Wojewódzki, Commerzbank"
            ],
            moderator: null
        },
        abstract: "I built Commissure, a distributed LLM runtime that splits large language models across multiple serverless GPU services and streams intermediate activations between them in real time. The project won the GPU Category in the International Google Cloud Run Hackathon."
    },
    {
        title: "Data-to-AI Journey",
        time: "10:00 - 10:30",
        details: {
            speakers: [
                "Jakub Skuratowicz, Google"
            ],
            moderator: null
        },
        abstract: "The session presents how data becomes the foundation for advanced AI-driven solutions and how to transform information into real business value in the financial sector."
    },
    {
        title: "From Integration to Intelligence: How MCP Is Reshaping Banking Technology",
        time: "10:30 - 11:00",
        details: {
            speakers: [
                "Ivanka Stoyanova",
                "Mariya Stoyanova, Commerzbank"
            ],
            moderator: null
        },
        abstract: "Connecting systems, data, and AI through shared context."
    },
    {
        title: "Coffee Break",
        time: "11:00 - 11:30",
        details: {
            speakers: [],
            moderator: null
        },
        abstract: ""
    },
    {
        title: "From Cloud-Native to Autonomous Operations: How Modern Azure Architectures Enable SRE Agents",
        time: "11:30 - 12:00",
        details: {
            speakers: [
                "Laurenz Frost, Commerzbank"
            ],
            moderator: null
        },
        abstract: "The talk explains how cloud-native Azure architectures, observability, and platform engineering create the foundation for SRE agents that interpret operational data, react to incidents, and support reliability at scale."
    },
    {
        title: "Discussion Panel: The Circles of Progress: Are Modern IT Architectures Truly Innovative or Just Reinterpretations of Existing Patterns?",
        time: "12:00 - 13:00",
        details: {
            speakers: [
                "Krzysztof Zalasa",
                "Mateusz Witkowski",
                "Andrzej Chodorowski",
                "Jakub Kołczynski"
            ],
            moderator: "Konrad Orzechowski"
        },
        abstract: "Panel discussion on whether modern architectures are true innovation or evolutions of existing patterns, with practical perspectives on scalability, reliability, and long-term value."
    },
    {
        title: "Lunch Break",
        time: "13:00 - 14:00",
        details: {
            speakers: [],
            moderator: null
        },
        abstract: ""
    },
    {
        title: "How Innovation Actually Happens: Why Most Companies Get It Wrong",
        time: "14:00 - 14:30",
        details: {
            speakers: [
                "Daniel Garcia, Yotpo"
            ],
            moderator: null
        },
        abstract: "Most companies try to force innovation with mandate and budget, but breakthroughs come when problems are framed clearly and failed experiments are treated as useful data."
    },
    {
        title: "How Distributed Innovation Bridges the Space Between Strategy and Reality",
        time: "14:30 - 15:00",
        details: {
            speakers: [
                "Marta Krysińska",
                "Jakub Wężykowski",
                "Sylwester Głowacki"
            ],
            moderator: null
        },
        abstract: "A practical model of distributed innovation showing how tactical solutions can deliver rapid value while preserving governance, with examples from financial services and future AI agent extensions."
    },
    {
        title: "A Case Study in Applying Machine Learning in the LLM Era",
        time: "15:00 - 15:30",
        details: {
            speakers: [
                "Vojtech Kotous, Commerzbank"
            ],
            moderator: null
        },
        abstract: "A real-world case study on using targeted machine learning for complex KYC challenges, with implementation lessons and practical guidance on choosing the right AI tool for the right job."
    },
    {
        title: "Beyond Patching Systems: How Innovative Architecture Eliminates Entire Classes of Vulnerabilities",
        time: "15:30 - 16:00",
        details: {
            speakers: [
                "Mateusz Lach, Commerzbank"
            ],
            moderator: null
        },
        abstract: "The session argues that the biggest security breakthroughs came from architectural innovation, not only better patching and defensive coding."
    },
    {
        title: "The Self-Proving Bank: Cybersecurity for the Agentic AI Era",
        time: "16:00 - 16:30",
        details: {
            speakers: [
                "Michał Krauze"
            ],
            moderator: null
        },
        abstract: "In the agentic AI era, security becomes an AI-vs-AI race. The session introduces the Self-Proving Bank approach based on verifiable trust, continuous assurance, and real-time validation, plus a 24-36 month implementation roadmap."
    }
];

const partnerLogos = [
    "logo_wer_podst_zhaslem_pl_kolor_rgb.jpg",
    "LogoLodzkieUM_kolor.png",
    "InvestinLodz.png.png",
    "ict_eng.png",
    "LogotypPolitechnikaLodzka.png",
    "ul_pol.png",
    "ms_gray.png",
    "google.png",
    "mbank.png",
    "Acc_Logo_Black_Purple_RGB.png",
    "Dakiyama_Takeda.png",
    "espeo_soft.jpg",
    "fintech.png",
    "fujitsu.png",
    "idemia.png",
    "absl.png",
    "O_Lodzki_logo-RGB-elektroniczne.png",
    "Makolab_logo.png",
    "nordea.png",
    "thecloudpeople-logo-google-forms.png",
    "TTPSC_logo_main_version.png",
    "yotpo-logo-freelogovectors.net_-400x109.png"
];

const partnerCompanies = [
    "ABSL",
    "Accenture",
    "Espeo Software",
    "Fintech Central Poland",
    "Fujitsu",
    "Google",
    "Idemia",
    "Invest in Łódź",
    "Lodz ICT Cluster",
    "Makolab",
    "mBank",
    "Microsoft",
    "Nordea",
    "Politechnika Łódzka",
    "Polskie Towarzystwo Informatyczne",
    "Takeda",
    "The Cloud People Global",
    "Transition Technologies PSC",
    "Uniwersytet Łódzki",
    "Urząd Marszałkowski województwa łódzkiego",
    "Urząd Miasta Łodzi",
    "Yotpo",
];

const defaultPartnerMailBodyTemplate = "Hello TechConnect team,\n\nPlease register me as a partner attendee for TechConnect 2026.\n\nCompany: {company}\nE-mail: {email}\nPassword: {password}\n\nBest regards,";

const tcTeam = [
    { name: "Łukasz Garliński", position: "Chapter Lead Securities Processes", url: "https://www.linkedin.com/in/lukasz-garlinski-02b08a54/", imageSrc: "../tc_team/lukasz_garlinski.JPG" },
    { name: "Andrzej Chodorowski", position: "Senior Test Engineer and Team Lead", url: "https://www.linkedin.com/in/andrzej-chodorowski-0b746921/", imageSrc: "../tc_team/Andrzej_Chodorowski.jpg" },
    { name: "Jakub Pawłowski", position: "Chapter Lead Wertpapier Prozess Development", url: "https://www.linkedin.com/in/kubapawlowski/", imageSrc: "../tc_team/jakub_pawlowski.png" },
    { name: "Karolina Garcia", position: "DevOps Engineer", url: "https://www.linkedin.com/in/karolinaagarcia/", imageSrc: "../tc_team/karolina_garcia.jpg" },
    { name: "Dominika Jastrząbek", position: "Senior Employer Branding & PR Specialist", url: "https://www.linkedin.com/in/dominikajastrzabek/", imageSrc: "../tc_team/dominika_jastrzabek.png" },
    { name: "Marlena Sajda", position: "IT Recruiter", url: "https://www.linkedin.com/in/marlenasajda/", imageSrc: "../tc_team/marlena_sajda.png" },
    { name: "Katarzyna Wełpa-Zajączkowska", position: "Scrum Master", url: "https://www.linkedin.com/in/katarzyna-welpa/", imageSrc: "../tc_team/katarzyna_welpa-zajaczkowska.jpg" },
    { name: "Aleksandra Kaźmierczak", position: "Chapter Lead", url: "https://www.linkedin.com/in/aleksandra-kaźmierczak-874a6778/", imageSrc: "../tc_team/aleksandra_kazmierczak.png" },
    { name: "Aleksandra Pirek", position: "Chapter Lead", url: "https://www.linkedin.com/in/aleksandra-pirek/", imageSrc: "../tc_team/aleksandra_pirek.jpg" },
    { name: "Krzysztof Wieczorkowski", position: "Application Manager", url: "https://www.linkedin.com/in/krzysztof-wieczorkowski-9051322b0/", imageSrc: "../tc_team/krzysztof_wieczorkowski.png" },
    { name: "Konrad Orzechowski", position: "Product Owner", url: "https://www.linkedin.com/in/konrad-orzechowski-a42000a2/", imageSrc: "../tc_team/konrad_orzechowski.png" },
    { name: "Grzegorz Sztandera", position: "Chapter Lead", url: "https://www.linkedin.com/in/grzegorzsztandera/", imageSrc: "../tc_team/grzegorz_sztandera.png" },
    { name: "Aleksandra Pawłowska", position: "Senior PR & Employer Branding Specialist", url: "https://www.linkedin.com/in/ale-pawlowska/", imageSrc: "../tc_team/aleksandra_pawlowska.png" },
    { name: "Barbara Michalak", position: "Talent Manager Specialist", url: "https://www.linkedin.com/in/barbara-michalak/", imageSrc: "../tc_team/barbara_michalak.jpg" },
];

const tcSpeakers = [
    {name: "Dominik Stöttner", position: "Divisional Board Member CIO Private & Small Business Customers, Commerzbank", imageSrc: "../tc_speakers/Stottner_Dominik.jpg", layerContent: (<><Paragraph>Dominik, born on October 17, 1980 in Linz, initially took on the role of Principal Project Manager in strategic product and channel management for private and business clients in Frankfurt after joining Commerzbank AG in April 2023. Since January 2024, he has been serving as Divisional Board Member CIO PUK in Group Services. Previously, he led various departments at Erste Digital GmbH as well as s IT Solutions AT, including the Retail & SME segment and the Enterprise & Core division. His academic career includes degrees in Business Informatics and Software Engineering from the Technical University of Vienna, as well as participation in the Executive MBA program at Danube University Krems.</Paragraph></>)},
    {name: "Agnieszka Belowska-Gosławska", position: "Chief Operating Officer for Group Compliance, Nordea", imageSrc: "../tc_speakers/Agnieszka_Belowska.jpg", layerContent: (<><Paragraph>Agnieszka is a seasoned executive and inspiring people leader with over 15 years of global experience in the Banking, Financial Services, and BPO sectors. With a powerful commitment to transparency, self-awareness, and determination, she brings both strategic insight and a deeply people-centered approach to her roles. Her executive journey is marked by a dedication to equal opportunity, competence, and operational excellence.</Paragraph><Paragraph>Agnieszka currently serves as Chief Operating Officer for Group Compliance and is also a Board Member of Nordea Poland, where she plays a pivotal role in shaping the organization’s strategic direction. Known for her ability to lead and inspire diverse, high-performing teams across continents and time zones, she excels at building scalable enterprise functions from early-stage capabilities. Her expertise spans Compliance, Automation, Digital Transformation, Strategy Implementation, and Business Transformation, consistently bridging the gap between business and technology to drive impactful outcomes.</Paragraph></>)},
    {name: "Aleksandra Grzelak", position: "Delivery Operations Director, Transition Technologies PSC S.A.", imageSrc: "../tc_speakers/Aleksandra_Grzelak_TTPSBC.jpg", layerContent: (<><Paragraph>Aleksandra has been working in the IT industry for over 15 years, supporting the areas of Workforce Management and Delivery Operations. At Transition Technologies PSC, she is responsible for operational excellence, process development and optimization. Additionally, as a co-founder of an internal organization Women in Power, she actively supports diversity and women’s growth in technology.</Paragraph></>)},
    {name: "PhD Marek Gajowniczek", position: "Head of Digital Technology Center of Commerzbank in Poland", imageSrc: "../tc_speakers/marek_gajowniczek.JPG", layerContent: (<><Paragraph>Marek Gajowniczek is the Head of the Commerzbank’s Digital Transformation Center (DTC) in Łódź, where he leads strategic initiatives driving innovation and modernization across banking technology. With extensive experience in IT leadership and large-scale transformation, he focuses on leveraging data, AI, and agile methodologies to enhance operational efficiency and deliver business value. Marek is recognized for building high-performing teams and bridging the gap between technology and business to support the future of digital banking.</Paragraph></>)},
    {name: "PhD Mirosław Sopek", position:"Founder and CEO of MakoLab", imageSrc: "../tc_speakers/Miroslaw_Sopek.jpg", layerContent: (<><Paragraph>Mirek Sopek holds a Ph.D. in theoretical and quantum chemistry and has a background in quantum physics. Since 2021, he has served as the elected Chair of the University Council of the Łódź University of Technology, promoting innovation and strengthening collaboration between academia and industry. In 1989, he founded MakoLab and led the company through a successful IPO on the Warsaw Stock Exchange in 2007. He has also founded two technology startups in the United States and is currently the founder and CEO of Quantum B, a company specializing in quantum cryptography, post-quantum security, and quantum-resilient digital infrastructure. His work focuses on helping organizations prepare for the impact of quantum computing on cybersecurity, digital identity, and critical infrastructure.</Paragraph></>)},
    {name: "Alessandra Dolfetti", position: "Managing Director / Cluster Lead, Commerzbank", imageSrc: "../tc_speakers/Alessandra_Dolfetti.jpg", layerContent: (<><Paragraph>Alessandra Dolfetti is Managing Director Securities Processes at Commerzbank, where she is responsible for the Order Management System and the Securities Settlement Platform. She brings over 20 years of leadership experience in the financial sector. She combines her deep understanding of the securities business with extensive project management experience and a strong affinity for IT.</Paragraph><Paragraph>Her journey into digitalization began in 2002 with her first digitalization project. Since then, she has actively driven the digitalization of processes as well as the migration and modernization of systems. In this context, Artificial Intelligence (AI) plays an increasingly central role. Her expertise lies in how these far-reaching transformations in the intersection of AI and Leadership can be successfully managed and shaped.</Paragraph><Paragraph>After a brief stay in London, Alessandra Dolfetti has been living in Germany since 1999. She holds a Master degree in Business Administration and Economics from the University of Genoa.</Paragraph></>)},
    {name: "Bartłomiej Szymański", position: "Managing Director / VP Digital Operations, Idemia", imageSrc: "../tc_speakers/Bartek_Szymanski_Idemia.jpg", layerContent: (<><Paragraph>I am an experienced leader with more than 19 years of practice managing local and distributed teams. I'm working in IT since 2006, taking care of complex systems and customers. Huge fan of well-designed processes, advocate of simplicity. I believe: "Failure is not an option" and "Every problem is an opportunity in disguise"</Paragraph></>)},
    {name: "Daniel Garcia", position: "Product Manager, Yotpo", imageSrc: "../tc_speakers/daniel_garcia.jpg", layerContent: (<><Paragraph>Daniel Garcia has nearly 30 years of experience in IT, working across development, management, and product roles. After serving as a senior manager in a large corporate environment, he stepped down to return to hands-on software and product development. That path gave him first-hand exposure to the realities of delivery, constraints, and trade-offs. Today, his focus is helping teams decide what to build when they cannot do everything.</Paragraph></>)},
    {name: "Dominik Zyskowski", position: "Consulting Director & Partner, Espeo Software", imageSrc: "../tc_speakers/dominik_zyskowski_espeo.jpg", layerContent: (<><Paragraph>Dominik has been with Espeo since 2013 and currently leads a team of consultants specializing in technology advisory for the financial sector. An expert in blockchain and DLT, he is a certified Hyperledger Fabric specialist. He advises banks, financial institutions, and fintech innovators on asset tokenization, digital-asset infrastructure, and strategic DLT adoption.</Paragraph><Paragraph>Dominik co-hosts the "On The Block" video series and regularly appears at Linux Foundation Decentralized Trust events—both as a speaker and within the LFDT European Chapter, of which Espeo Software is a founding member.</Paragraph></>)},
    {name: "Edyta Sikorska", position: "Head of HR, Commerzbank Poland", imageSrc: "../tc_speakers/Edyta_Sikorska.JPG", layerContent: (<><Paragraph>Edyta Sikorska is Head of Human Resources at Commerzbank in Poland, leading HR strategies focused on attracting, developing, and retaining talent. With over 15 years of experience, she specializes in building high-performing teams and aligning HR with business goals, while fostering an inclusive workplace culture.</Paragraph></>)},
    {name: "Grzegorz Sztandera", position: "Chapter Lead, Commerzbank", imageSrc: "../tc_speakers/grzegorz_sztandera.jpg", layerContent: (<><Paragraph>Technology and change leader in banking, combining hands on delivery with a strong focus on people and culture. He has over a decade of experience in Product, Project and People management across large institutions, where he drives digital transformation initiatives, builds high performing teams and helps translate complex IT capabilities into real business value.</Paragraph><Paragraph>Previously involved in telecommunications, automotive, aviation and healthcare projects. TEDx speaker, organizer and speaker coach. Grzegorz regularly works with experts and executives to sharpen their communication and storytelling around technology and innovation. He believes that sustainable efficiency and quality in banking are only possible in close knit, cooperative teams - which is why “people first” is the principle behind his work as a leader, trainer and conference speaker. He always ask one question: “What if we will do it differently?”.</Paragraph></>)},
    {name: "Igor Savic", position: "Head of Digital Technology Center of Commerzbank in Czech Republic", imageSrc: "../tc_speakers/Igor_Savic.jpg", layerContent: (<><Paragraph>My IT career began at an Internet café, where I undertook multiple roles including IT support and night guard. While studying at university, I joined Commerzbank Prague business branch and was tasked with system administration and implementing a central antivirus solution.</Paragraph><Paragraph>Later, I transitioned to a major consultancy firm as a security-focused consultant, where I gained my negotiation skills and effectively managed customer relations.</Paragraph><Paragraph>At the age of 24 I got an offer from Commerzbank to return back as a Project Manager, leading a team of developers utilizing SCRUM, later also leading a service delivery teams.</Paragraph><Paragraph>Then I moved from core IT projects in Commerzbank to leading a service delivery department at Commerz Systems. Since 2021, I have been heading the Digital Technology Center in Prague, this year reaching over 700 technical and business experts.</Paragraph></>)},
    {name: "Ivanka Stoyanova", position: "Chapter Lead, Commerzbank", imageSrc: "../tc_speakers/ivanka_stoyanova.png", layerContent: (<><Paragraph>Ivanka Stoyanova is a Chapter Lead in Business Connectivity cluster at Commerzbank working on initiatives that connect systems, data, and AI to enhance the bank’s technology landscape. She is actively involved in advancing digital transformation topics, including integration and intelligent data usage, shaping future-ready technology solutions. At the #TechConnect IT Conference, she shares insights on how modern connectivity approaches—such as MCP—are reshaping banking technology and unlocking new business value.</Paragraph></>)},
    {name: "Karolina Brzozowska", position: "Academy Manager, The Cloud People Global", imageSrc: "../tc_speakers/Karolina_Brzozowska.jpg", layerContent: (<><Paragraph>Karolina Brzozowska explores the future of human capability in the age of AI.</Paragraph><Paragraph>As a Capability & Learning Leader, speaker and Gallup-certified coach, she works at the intersection of technology, consulting and psychology - helping organizations build cultures of ownership, adaptability, trust and meaningful performance in times of rapid transformation.</Paragraph><Paragraph>Her work focuses on one key belief: the more AI we build, the more human-aware we must become</Paragraph></>)},
    {name: "Krzysztof Zalasa", position: "Principal Architect, Google", imageSrc: "../tc_speakers/Krzysztof_Zalasa_Google.jpg", layerContent: (<><Paragraph>Krzysztof is a Principal Architect at Google Cloud, bringing over seven years of experience within the company and a deep technical specialization in the retail and healthcare sectors. Having worked with public cloud technologies since 2010, he has a strong foundation as a software and solutions architect, previously building global, multimillion-dollar deployments for Fortune 500 companies. More recently, he has successfully led multiple large-scale digital transformations for top enterprises across Poland. Passionate about the intersection of AI and business, Krzysztof actively builds LLM models in his free time and researches their impact and adoption within enterprise architectures. A self-taught programmer from the age of 15 who also studied psychology, he remains a dedicated advocate for continuous improvement and delivering client-centric solutions.</Paragraph></>)},
    {name: "Laurenz Frost", position: "Principal Solution Architect, Commerzbank", imageSrc: "../tc_speakers/Laurenz_Frost.png", layerContent: (<><Paragraph>Laurenz Frost is a Principal Solution Architect based in Frankfurt, specializing in cloud-native architectures and Azure-based platforms in the financial industry.</Paragraph><Paragraph>With over 12 years of experience, he has led large-scale transformation initiatives and focuses on modernizing legacy systems into scalable, fully managed cloud solutions.</Paragraph><Paragraph>His current work explores how automation, observability, and AI-driven SRE agents can improve reliability and move operations towards more intelligent and adaptive systems.</Paragraph></>)},
    {name: "PhD Magdalena Wróbel-Lachowska", position: "Assistant Professor at the Institute of Applied Computer Science at Lodz University of Technology", imageSrc: "../tc_speakers/Magdalena_Wrobel-Lachowska_Politechnika.jpg", layerContent: (<><Paragraph>Magdalena Wróbel-Lachowska is an Assistant Professor at the Institute of Applied Computer Science at Lodz University of Technology. With a background in economics and sociology, her research focuses on Human-Computer Interaction (HCI), human factors, and the design of user-centered, multisensory systems. As a member of the UbiComp Research Group, she explores how technology shapes user experience, also in education and inclusive digital environments. She is also actively involved in science communication, co-hosting the podcast "Sztuczna inteligencja po ludzku" ("AI in Human Terms"), where she discusses the human side of digital transformation.</Paragraph></>)},
    {name: "Prof. Dominika Kaczorowska-Spychalska", position: "Professor at the Lodz University", imageSrc: "../tc_speakers/Dominika_Kaczorowska-Spychalska.jpg", layerContent: (<><Paragraph>Dr. Dominika Kaczorowska‑Spychalska, Professor at the University of Łódź – Advisor to the Dean of the Faculty of Management at the University of Łódź for AI and Digital Education.</Paragraph><Paragraph>She is a member of the Artificial Intelligence Working Group at the Ministry of Digital Affairs and the Digital Education Section of the Committee on Informatics of the Polish Academy of Sciences.</Paragraph><Paragraph>An AI enthusiast, including generative AI, she supports and develops collaboration between academia and business at both national and international levels, for which she received an award from the Minister of Science and Education.</Paragraph><Paragraph>In 2025, she was included in a prestigious ranking of experts actively shaping the Polish AI ecosystem, published by Marketing i Rynek.</Paragraph></>)},
    {name: "Małgorzata Kapral", position: "HR Services Optimisation & Transformation Leader", imageSrc: "../tc_speakers/Malgorzata_Kapral.jpg", layerContent: (<><Paragraph>HR leader with 15+ years of experience across HR Business Partnering, Talent, Change, and Transformation in complex global organizations. I combine strategic people leadership with strong operational execution across organizational effectiveness, succession planning, employee experience, rewards partnership, and HR transformation. My background includes support for global projects, data-driven people decision-making, cross-functional stakeholder leadership, and digital HR initiatives including process automation, analytics, and AI-related workstreams. I bring deep experience partnering with senior leaders to strengthen organizational capability, improve HR service delivery, and enable business growth in fast-changing environments.</Paragraph></>)},
    {name: "Mariya Stoyanova", position: "Product Owner, Commerzbank", imageSrc: "../tc_speakers/Mariya_Stoyanova.JPG", layerContent: (<><Paragraph>Mariya Stoyanova  have been working at Commerzbank since 2022. SHe started my journey here as a Product Owner, building up a new team from scratch and leading the development of “Cobakibana” – a monitoring solution for API logs and other product logs from both within and outside the Business Connectivity cluster. Currently, responsible for integrating an API security tool from Akamai, which is designed to detect API threats and potential attacks and provide timely notifications. Through these initiatives, She focus on improving transparency, reliability and security in our API landscape and supporting the bank’s broader digitalization efforts.</Paragraph></>)},
    {name: "Marta Krysińska", position: "Senior Project Leader in Group Compliance, Nordea", imageSrc: "../tc_speakers/Marta_Krysinska_Nordea.jpg", layerContent: (<><Paragraph>Marta Krysińska is a Senior Project Manager in Group Compliance at Nordea with more than 25 years of experience leading complex projects, business transformations, and organizational change initiatives. Passionate about innovation and the practical application of AI, she specializes in bridging the gap between strategic ambition and operational reality. Throughout her career, she has helped organizations deliver meaningful outcomes by combining structured project management with pragmatic, people-centered approaches to change. Her current interests include AI-enabled transformation, organizational agility, and innovative project delivery methods.</Paragraph></>)},
    {name: "Mateusz Witkowski", position: "Senior Java Developer, Commerzbank", imageSrc: "../tc_speakers/Mateusz_Witkowski.jpg", layerContent: (<><Paragraph>Mateusz is a Java developer with over 12 years of experience in the technology field. He has strong experience with many different technologies, using them to solve problems and create useful solutions. Over the years, he has worked on all parts of technology- from building software to designing systems, working with cloud platforms, and even improving older systems. He enjoys finding solutions that are practical, efficient, and help businesses succeed. At the conference, Mateusz will share easy-to-understand stories and tips that show how technology can make a difference and help others improve.</Paragraph></>)},
    {name: "Michał Wojewódzki", position: "Senior Software Developer, Commerzbank", imageSrc: "../tc_speakers/Michal_Wojewodzki.jpg", layerContent: (<><Paragraph>Michał Wojewódzki is a Senior Software Engineer and AI Guild Master with nearly four years at Commerzbank. He is a two-time winner of international AI hackathons organized by AWS and Google. He is a passionate AI practitioner with a background in software development, DevOps, and high-performance computing.</Paragraph></>)},
    {name: "Przemysław Koper", position: "Chief Executive Officer, Espeo Software", imageSrc: "../tc_speakers/Przemyslaw_Koper_Espeo.jpg", layerContent: (<><Paragraph>Przemek has been serving as the CEO of Espeo Software since September 2023. Previously, he headed the business development department at Espeo, drawing on extensive experience gained in the banking and fintech sectors at companies such as Knowit, Commerzbank, and Travelex.</Paragraph><Paragraph>He focuses on driving Espeo’s growth as a European technology consultant for the financial sector, with a particular emphasis on blockchain and digital assets. Przemek is also an active participant in the Linux Foundation Decentralized Trust ecosystem—Espeo is a founding member of the organization as well as the founder of its European Chapter. He regularly represents the company at key industry events (including Money20/20, GITEX Global, and Seamless) and hosts Espeo's original video series, "On The Block."</Paragraph></>)},
    {name: "Sandra Flavia Fensterseifer", position: "Cluster Lead, Commerzbank", imageSrc: "../tc_speakers/Sandra_Fensterseifer.jpg", layerContent: (<><Paragraph>Sandra Flavia Fensterseifer is Managing Director of the Innovation Lab at Commerzbank AG, where she leads the development of strategic innovation topics with a strong focus on emerging technologies such as Artificial Intelligence and Distributed-Ledger Technologies.</Paragraph><Paragraph>Her career at Commerzbank is defined by the intersection of technology, product development, and tangible customer value. She has driven the creation of digital banking products and successfully launched an AI-powered banking avatar, demonstrating how cutting edge technology can become real, scalable solutions.</Paragraph><Paragraph>In her role, she transforms ideas into impactful products, and shapes the future of digital banking through pragmatic execution and technological vision</Paragraph></>)},
    {name: "Vojtech Kotous", position: "Head of KYC Business and Data Intelligence, Commerzbank", imageSrc: "../tc_speakers/Vojtech_Kotous.jpg", layerContent: (<><Paragraph>Vojtech Kotous is the Head of KYC Business and Data Intelligence at Commerzbank, bringing over 20 years of IT delivery experience to the role, with the last decade focused exclusively on the KYC domain. His leadership is defined by a deep understanding of both the business domain and technical execution, which he uses to guide his teams in building effective, data-driven solutions like machine learning models. Vojtech is known for his pragmatic approach and a relentless focus on execution, ensuring that complex projects solve critical compliance problems and deliver tangible results.</Paragraph></>)},
    {name: "Karolina Bioch-Spicola", position: "Head of HR Shared Services, Fujitsu", imageSrc: "../tc_speakers/karolina_bioch-spicola.png", layerContent: (<><Paragraph>Karolina Bioch-Spicola has built an 18-year career in Human Resources. She began in recruitment and HR operations, then spent the last 14 years in learning and development roles at companies including Whirlpool, IKEA, and Fujitsu. Her international experience spans both people and process management, developed through work in China, Germany, the United Kingdom, Sweden, and Italy. This broad cultural perspective informs her daily work and leadership approach. Since 2019, she has worked at Fujitsu, where she currently serves as Head of HR Shared Services.</Paragraph><Paragraph>She is a graduate of the University of Lodz and has taken part in development initiatives such as the AIESEC student organization and the IKEA talent development program. She continues to strengthen her coaching skills and has mentored employees for many years. She has also delivered training in both managerial and soft-skill programmes, creating opportunities to share knowledge while continuing to learn from others. </Paragraph><Paragraph>She advocates leadership by example. In her view, leaders should combine strong personal example with clear vision, enabling people to deliver the best solutions for both internal and external customers. She believes that ‘sky is the limit’ and that people should keep pushing themselves and others to reach the ‘sky’ without giving up on their ambitions.</Paragraph></>)},
    {name: "Michał Furmankiewicz", position:"Senior Solution Engineer, AI & Apps, Microsoft", imageSrc: "../tc_speakers/Michal_Furmankiewicz.jpg", layerContent: (<><Paragraph>Michal Furmankiewicz is a technology leader specializing in cloud transformation, AI adoption, and enterprise modernization, with a strong track record of driving impact across global organizations. He combines deep technical expertise with strategic execution, helping companies accelerate innovation, optimize architectures, and build high-performing engineering cultures. Michal is recognized for his ability to translate complex technology into business value, lead cross-functional teams, and deliver measurable outcomes in fast-changing environments.</Paragraph></>)},
    {name: "Jakub Skuratowicz", position: "Data Analytics Solution Lead, Google", imageSrc: "../tc_speakers/Jakub_Skuratowicz.jpg", layerContent: (<><Paragraph>Data has always been my obsession — but what keeps me up at night now is how we make it trustworthy enough for AI to act on.</Paragraph><Paragraph>I lead data analytics solution architecture at Google, working with organizations across Europe to design and deploy modern data platforms on Google Cloud. My focus sits at the intersection of three things: data governance, generative AI, and the engineering that connects them.</Paragraph><Paragraph>Over the past few years, I've gone deep on Dataplex as a knowledge catalog — not just as a metadata store, but as an active system that can drive AI agents, propagate lineage, and automate governance at scale. I believe the shift from pull-based to event-driven data governance (agents that react to changes, not just answer questions) is the most underrated transformation happening in data right now.</Paragraph><Paragraph>Before Google, I spent years in the data warehouse trenches — Oracle, Teradata, IBM Netezza, Informatica, Cognos — designing and selling analytical systems that had to work reliably in production. That grounding in the fundamentals shapes how I think about every new AI-powered abstraction: what breaks when the context is wrong, where the lineage gaps hide, why metadata quality determines AI quality.</Paragraph><Paragraph>What I work on:</Paragraph><Paragraph>- Helping customers design AI-ready data platforms on BigQuery and Dataplex</Paragraph><Paragraph>- Building and open-sourcing tools around data lineage, metadata generation, and NL2SQL</Paragraph><Paragraph>- Writing about data governance for the Google Cloud Community on Medium</Paragraph><Paragraph>- Organizing the BigQuery &amp; Gemini community in Poland</Paragraph><Paragraph>Currently exploring: event-driven governance agents, Conversational Analytics and context management, and multi-agent data pipelines with ADK.</Paragraph></>)},
    {name: "Jakub Wężykowski", position:"Lead Change & Process Specialist in Group Compliance, Nordea", imageSrc: "../tc_speakers/Jakub_Wezykowski.jpg", layerContent: (<><Paragraph>Jakub Wężykowski is a Lead Change & Process Specialist in Group Compliance at Nordea, with experience across data risk, audit, and regulatory compliance. He focuses on analyzing complex business problems and translating them into practical, developer-ready solutions that strengthen risk management and governance processes. Passionate about the real-world application of AI, he drives initiatives that enable more efficient, data-driven compliance operations. His work combines structured analytical thinking with a pragmatic approach to automation and process improvement. His current interests include AI adoption in compliance, data governance, and scalable approaches to measuring business impact from digital solutions.</Paragraph></>)},
    {name: "Sylwester Głowacki", position:"Change & Process Specialist in Group Compliance, Nordea", imageSrc: "../tc_speakers/Sylwester_Glowacki.jpg", layerContent: (<><Paragraph>Sylwester Głowacki is a Change & Process Specialist in Group Compliance at Nordea, with a background spanning business analysis, IT, product ownership, and process improvement. He works on turning compliance and operational needs into practical, scalable solutions, with a strong focus on the internal reporting platform, internal risk register, and related automation initiatives.</Paragraph><Paragraph>His work brings together structured analysis, documentation, and close collaboration with developers and stakeholders to improve reporting, testing, and governance processes. He holds a PhD in Life Sciences and brings a evidence-based, continuous-improvement mindset to solving complex business problems.</Paragraph></>)},
    {name: "Ariel Zgórski", position:"IT area lead/ AI Strategist, ING", imageSrc:"../tc_speakers/Ariel_Zgorski.jpg", layerContent: (<><Paragraph>Ariel is an experienced IT Manager in a global banking environment, working with international teams across Europe, Asia, and the United States. He focuses on leveraging modern technologies and AI to create measurable business impact in financial services, with a strong emphasis on innovation and strategic transformation.</Paragraph><Paragraph>He is actively involved in Artificial Intelligence and emerging technology trends, with a particular interest in how generative AI, automation, and data-driven systems are reshaping the future of banking. As an AI ambassador and speaker, he explores the intersection of technology, futurology, and finance, translating complex technological shifts into practical insights for business leaders.</Paragraph></>)},
    {name: "Mateusz Lach", position:"Senior Software Engineer, Commerzbank", imageSrc: "../tc_speakers/Mateusz_Lach.png", layerContent: (<><Paragraph>Software engineer with over 15 years of professional experience. Since the beginning of his career, he has focused on creating secure code, treating application security as an integral part of the software development process. When he finishes writing code, he tests its security - both commercially and as a hobby. Author of IT educational materials, book and several articles published in magazines devoted to Linux. In the past, an academic lecturer in programming subjects and a mentor in the field of Java. He holds certifications as Certified Ethical Hacker, Professional Scrum Master, and OCAJP. </Paragraph></>)},
    {name: "Michał Krauze", position:"Founder, Principal Advisor, Executive Advisory", imageSrc:"../tc_speakers/Michal_Krauze.jpg", layerContent: (<><Paragraph>Michał Krauze is an executive leader specializing in business transformation, digital strategy, operational excellence and AI-driven innovation. Over the past 18 years, he has led international teams and transformation programs across multiple European markets, combining technology, process excellence and business strategy to deliver sustainable growth and operational efficiency. His experience spans executive leadership, digital operations, automation, quality management, commercial growth and organizational transformation. Michał regularly advises business leaders on how to translate emerging technologies into measurable business value.</Paragraph></>)},
    {name: "Łukasz Belica", position:"Artificial Intelligence Program Lead, Takeda", imageSrc:"../tc_speakers/Lukasz_Belica.jpg", layerContent: (<><Paragraph>With over 15 years of experience in IT, I have held various technical and managerial roles at leading global companies including Capgemini, Danone, ISS World Services, and Takeda at the moment, successfully driving digital transformations across diverse IT and business domains. Currently, as the Artificial Intelligence Program Lead, I shape the vision and strategy for AI, focusing on process automation within Finance, Procurement and HR, accelerating the digital transformation of Global Business Services (GBS). Both personally and professionally, I am guided by the motto "Love what you do", reflecting my passion and deep commitment to my work</Paragraph></>)},
    {name: "Robert Buda", position:"Senior GenAI Product Owner, Senior IT Manager - AI, MBank", imageSrc:"../tc_speakers/Robert_Buda.jpg", layerContent: (<><Paragraph>Senior IT Manager – AI at mBank, where he is responsible for the development of artificial intelligence solutions that combine business, product, and technological perspectives. In his work, he focuses both on the use of generative AI—among others, to support bank employees, automate customer service, and enable analytics and document processing—and on the development of solutions based on classical machine learning for detecting suspicious transactions and strengthening security.</Paragraph><Paragraph>Before joining the banking sector, he also worked in academia, including at the Institute of Physical Chemistry of the Polish Academy of Sciences and the University of Leeds. He is a co-author of scientific publications in the field of smart materials and tissue engineering, and a passionate enthusiast of nanotechnology and quantum physics.</Paragraph></>)},
    {name: "Jakub Kolczyński", position:"Senior Manager, Accenture", imageSrc:"../tc_speakers/Jakub_Kolczynski.jpg", layerContent: (<><Paragraph>Jakub Kolczynski is a Project manager and software architect with 20 years of professional experience, with strong technical background in software development. Completed numerous software implementation projects for international companies in Retail, Telecommunication and Logistic industries. Specializes in system integration and cloud solutions.</Paragraph></>)},
    {name: "Andrzej Chodorowski", position:"Chapter Lead, Commerzbank", imageSrc: "../tc_team/Andrzej_Chodorowski.jpg", layerContent: (<><Paragraph>Andrzej is the Chapter Lead of Data & Visual Developers at Commerzbank, with over 12 years of professional experience in Quality Assurance, including five years devoted to testing banking applications. Over the course of my career, I have progressed through various roles – from Junior QA, Specialist and Architect to Manager, QA Lead and Team Lead – which has given me a comprehensive perspective on software quality processes and practices. I am particularly driven by the opportunity to create a tangible impact on the product and to continuously enhance its quality; outside of work, I enjoy badminton, table tennis, board games and travelling.</Paragraph></>)}
]

class FourPartPage extends Page {

    constructor(props) {
        super(props);
        const query = `query ReadOneFourPartPage($Locale: Locale, $Filter: FourPartPageFilterFields){
  readOneFourPartPage(locale: $Locale, filter: $Filter) {
      title,
      heroImage {
        ...on Image{
          fileFilename,
          absoluteLink
        }
      },
      part1Title,
      content,
      part1Image {
        ...on Image{
          fileFilename,
          absoluteLink
        }
      },
      part2Title,
      part2Text,
      part2Image {
        ...on Image{
          fileFilename,
          absoluteLink
        }
      },
      part3Title,
      part3Text,
      part3Image {
        ...on Image{
          fileFilename,
          absoluteLink
        }
      },
      part4Title,
      part4Text,
      part4Image {
        ...on Image{
          fileFilename,
          absoluteLink
        }
      },
}
}`;

        this.state = {
            ...this.state,
            pageData: {
                heroImage: {
                    absoluteLink: 'header_home-min.png'
                }
            },
            query,
            filters: null,
            open1: false,
            open2: false,
            open3: false,
            open4: false,
            showAllSpeakers: false,
            isCountdownPinned: false,
            isRegistrationLayerOpen: false,
            showPartnerSubmenu: false,
            partnerCompany: "",
            partnerEmail: "",
            partnerPassword: "",
            partnerFormError: "",
            isAgendaLayerOpen: false,
            selectedAgendaItem: null
        };

        this.pageRef = React.createRef();
        this.countdownTriggerRef = React.createRef();

        this.toggleDrawer1 = this.toggleDrawer1.bind(this);
        this.toggleDrawer2 = this.toggleDrawer2.bind(this);
        this.toggleDrawer3 = this.toggleDrawer3.bind(this);
        this.toggleDrawer4 = this.toggleDrawer4.bind(this);
        this.toggleSpeakersVisibility = this.toggleSpeakersVisibility.bind(this);
        this.handleCountdownStickyState = this.handleCountdownStickyState.bind(this);
        this.openRegistrationLayer = this.openRegistrationLayer.bind(this);
        this.closeRegistrationLayer = this.closeRegistrationLayer.bind(this);
        this.openPartnerSubmenu = this.openPartnerSubmenu.bind(this);
        this.handlePartnerCompanyChange = this.handlePartnerCompanyChange.bind(this);
        this.handlePartnerEmailChange = this.handlePartnerEmailChange.bind(this);
        this.handlePartnerPasswordChange = this.handlePartnerPasswordChange.bind(this);
        this.submitPartnerRegistration = this.submitPartnerRegistration.bind(this);
        this.openAgendaLayer = this.openAgendaLayer.bind(this);
        this.closeAgendaLayer = this.closeAgendaLayer.bind(this);
    }

    componentDidMount() {
        super.componentDidMount();
        window.addEventListener('scroll', this.handleCountdownStickyState, {passive: true});
        window.addEventListener('resize', this.handleCountdownStickyState);
        window.requestAnimationFrame(this.handleCountdownStickyState);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleCountdownStickyState);
        window.removeEventListener('resize', this.handleCountdownStickyState);
    }

    getCountdownStickyOffset() {
        if (!this.pageRef.current) {
            return 96;
        }

        const stickyOffset = window.getComputedStyle(this.pageRef.current)
            .getPropertyValue('--four-part-page-sticky-offset');

        return Number.parseInt(stickyOffset, 10) || 96;
    }

    handleCountdownStickyState() {
        if (!this.countdownTriggerRef.current) {
            return;
        }

        const stickyOffset = this.getCountdownStickyOffset();
        const shouldPin = this.countdownTriggerRef.current.getBoundingClientRect().top <= stickyOffset;

        if (shouldPin !== this.state.isCountdownPinned) {
            this.setState({isCountdownPinned: shouldPin});
        }
    }

    toggleDrawer1() {
        this.setState(prevState => ({ open1: !prevState.open1 }));
    }

    toggleDrawer2() {
        this.setState(prevState => ({ open2: !prevState.open2 }));
    }

    toggleDrawer3() {
        this.setState(prevState => ({ open3: !prevState.open3 }));
    }

    toggleDrawer4() {
        this.setState(prevState => ({ open4: !prevState.open4 }));
    }

    toggleSpeakersVisibility() {
        this.setState(prevState => ({ showAllSpeakers: !prevState.showAllSpeakers }));
    }

    openRegistrationLayer() {
        this.setState({
            isRegistrationLayerOpen: true,
            showPartnerSubmenu: false,
            partnerCompany: "",
            partnerEmail: "",
            partnerPassword: "",
            partnerFormError: ""
        });
    }

    closeRegistrationLayer() {
        this.setState({
            isRegistrationLayerOpen: false,
            showPartnerSubmenu: false,
            partnerCompany: "",
            partnerEmail: "",
            partnerPassword: "",
            partnerFormError: ""
        });
    }

    openPartnerSubmenu() {
        this.setState({ showPartnerSubmenu: true, partnerFormError: "" });
    }

    handlePartnerCompanyChange(event) {
        this.setState({ partnerCompany: event.target.value, partnerFormError: "" });
    }

    handlePartnerEmailChange(event) {
        this.setState({ partnerEmail: event.target.value, partnerFormError: "" });
    }

    handlePartnerPasswordChange(event) {
        this.setState({ partnerPassword: event.target.value, partnerFormError: "" });
    }

    getPartnerRegistrationMailtoHref(company, email, password) {
        const subject = this.props.partnerRegistrationMailSubject || "TechConnect 2026 - Partner registration";
        const bodyTemplate = this.props.partnerRegistrationMailBodyTemplate || defaultPartnerMailBodyTemplate;
        const body = bodyTemplate
            .replace(/{company}/g, company)
            .replace(/{email}/g, email)
            .replace(/{password}/g, password);

        return `mailto:innovativeminds@commerzbank.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    }

    submitPartnerRegistration() {
        const company = this.state.partnerCompany.trim();
        const email = this.state.partnerEmail.trim();
        const password = this.state.partnerPassword.trim();

        if (!company || !email || !password) {
            this.setState({ partnerFormError: "Please select company and provide e-mail and password." });
            return;
        }

        window.location.href = this.getPartnerRegistrationMailtoHref(company, email, password);
    }

    openAgendaLayer(stage, item) {
        this.setState({
            isAgendaLayerOpen: true,
            selectedAgendaItem: {
                ...item,
                stage
            }
        });
    }

    closeAgendaLayer() {
        this.setState({
            isAgendaLayerOpen: false,
            selectedAgendaItem: null
        });
    }

    normalizeAgendaDetails(details) {
        if (!details) {
            return null;
        }

        if (typeof details === "string") {
            const normalizedText = details.trim();
            return normalizedText ? { speakers: [normalizedText], moderator: null } : null;
        }

        const speakers = Array.isArray(details.speakers)
            ? details.speakers.filter((speaker) => typeof speaker === "string" && speaker.trim()).map((speaker) => speaker.trim())
            : [];
        const moderator = typeof details.moderator === "string" && details.moderator.trim()
            ? details.moderator.trim()
            : null;

        if (!speakers.length && !moderator) {
            return null;
        }

        return details;
    }

    isBreakAgendaItem(item) {
        return Boolean(item && typeof item.title === "string" && /break/i.test(item.title));
    }

    isClosingAgendaItem(item) {
        return Boolean(item && typeof item.title === "string" && /closing speech/i.test(item.title));
    }

    isSharedBreakRow(row) {
        if (!row || !row.stage1Item || !row.stage2Item) {
            return false;
        }

        if (!this.isBreakAgendaItem(row.stage1Item) || !this.isBreakAgendaItem(row.stage2Item)) {
            return false;
        }

        const normalizeTitle = (title) => title.trim().replace(/\s+/g, " ").toLowerCase();
        return normalizeTitle(row.stage1Item.title) === normalizeTitle(row.stage2Item.title);
    }

    buildAgendaRows(stage1Items, stage2Items) {
        const rows = [];

        if (stage1Items.length > 0) {
            rows.push({
                time: stage1Items[0].time,
                stage1Item: stage1Items[0],
                stage2Item: null,
                isFullWidth: true
            });
        }

        const stage1Remaining = stage1Items.slice(1);
        const rowCount = Math.max(stage1Remaining.length, stage2Items.length);

        for (let index = 0; index < rowCount; index += 1) {
            const stage1Item = stage1Remaining[index] || null;
            const stage2Item = stage2Items[index] || null;

            rows.push({
                time: stage1Item ? stage1Item.time : (stage2Item ? stage2Item.time : ""),
                stage1Item,
                stage2Item,
                isFullWidth: this.isClosingAgendaItem(stage1Item) && !stage2Item
            });
        }

        return rows;
    }

    render() {
        const isLoaded = this.state.loaded;
        const visibleSpeakers = this.state.showAllSpeakers ? tcSpeakers : tcSpeakers.slice(0, 6);
        const employeesRegistrationUrl = this.props.employeesRegistrationUrl || "https://apps.powerapps.com.mcas.ms/play/e/default-2d75a51b-29e5-45d5-a5c5-5aa979cb6a28/a/cedf6192-6b27-4c5b-8c7f-0650938934a9?tenantId=2d75a51b-29e5-45d5-a5c5-5aa979cb6a28&hint=a8af729f-cef6-4eb9-9ac1-7e77bc0ee020&sourcetime=1782134291489&source=portal#";
        const selectedAgendaItem = this.state.selectedAgendaItem;
        const selectedAgendaDetails = selectedAgendaItem ? this.normalizeAgendaDetails(selectedAgendaItem.details) : null;
        const agendaRows = this.buildAgendaRows(stage1Agenda, stage2Agenda);
        const renderAgendaItem = (stageName, item, rowIndex, additionalClassName = "") => {
            if (!item) {
                return <div className="agenda-stage-label agenda-stage-label--empty" aria-hidden="true" />;
            }

            const detailsPreview = this.normalizeAgendaDetails(item.details);

            return (
                <div
                    className={`agenda-stage-label${additionalClassName}`}
                    key={`${stageName}-${item.time}-${item.title}-${rowIndex}`}
                    role="button"
                    tabIndex={0}
                    onClick={() => this.openAgendaLayer(stageName, item)}
                    onKeyDown={(event) => {
                        if (event.key === "Enter" || event.key === " ") {
                            event.preventDefault();
                            this.openAgendaLayer(stageName, item);
                        }
                    }}
                    aria-label={`Open details for ${stageName} event: ${item.time} ${item.title}`}
                >
                    <Headline size="h5" as="h5">{`${item.time}`}</Headline>
                    <Headline size="h4" as="h4">{`${item.title}`}</Headline>
                    {detailsPreview && (
                        <>
                            {detailsPreview.speakers.length > 0 && (
                                <>
                                    <Headline size="h6" as="h6">Speakers:</Headline>
                                    <Paragraph>{detailsPreview.speakers.join(", ")}</Paragraph>
                                </>
                            )}
                            {detailsPreview.moderator && (
                                <>
                                    <Headline size="h6" as="h6">Moderator:</Headline>
                                    <Paragraph>{detailsPreview.moderator}</Paragraph>
                                </>
                            )}
                        </>
                    )}
                </div>
            );
        };
        if (isLoaded) {
            return (
                <div className="four-part-page" ref={this.pageRef}>
                    <Stage
                        theme={Stage.Themes.DARK}
                        scrollerText={this.state.scrollerText[this.props.lang.lang.label]}
                        backgroundImageImgSrc={this.state.pageData.heroImage.absoluteLink}
                    />
                    <OnPageNavigation
                        id={"navi-1"}
                        navigationTree={navigationTree}
                        activeElementName="item-1"
                    />
                    <div ref={this.countdownTriggerRef} className="four-part-page__countdown-trigger" aria-hidden="true" />
                    <div className={`four-part-page__countdown-sticky${this.state.isCountdownPinned ? ' is-pinned' : ''}`}>
                        <div className="four-part-page__countdown-sticky-content">
                            <BookmarkCountdown
                                title="TechConnect 2026 begins in:"
                                targetDate="2026-09-04T09:00:00"
                                lang="en"
                                titleTag="h2"
                                expiredText="Waiting time is over! See you at TechConnect."
                                isPinned={this.state.isCountdownPinned}
                            />
                        </div>
                    </div>
                    <Section id="section-1">
                        <Grid.Row>
                            <Grid.Column size={12}>
                                <Headline size="h1" as="h1" >{this.state.pageData.part1Title}</Headline>
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row>
                            <Grid.Column size={6}>
                                <Paragraph>
                                    TechConnect is a unique conference designed for professionals at the crossroads of IT, banking and finance. The event brings together industry leaders, experts, and innovators to discuss emerging technologies, digital transformation and solutions shaping the future of financial services - from cybersecurity and AI to fintech breakthroughs.
                                </Paragraph>
                                <H2>Inside TechConnect 2026</H2>
                                <Paragraph>Friday, 4th September 2026 (full-day event)</Paragraph>
                                <Paragraph>Location: <Link href="https://maps.app.goo.gl/fCCAfWWtm7byHSVg9" htmlAttrs={{ target: "_blank", rel: "noopener noreferrer" }}>Academy of Fine Arts, Łódź, Poland</Link></Paragraph>
                                <Button className="four-part-page__register-trigger" onClick={this.openRegistrationLayer}>
                                    Register now!
                                </Button>
                            </Grid.Column>
                            <Grid.Column size={6}>
                                <Picture imgSrc={this.state.pageData.part1Image.absoluteLink}/>
                            </Grid.Column>
                        </Grid.Row>
                    </Section>
                    <Layer
                        closeLinkLabel={"Close"}
                        returnFocus={true}
                        open={this.state.isRegistrationLayerOpen}
                        onCloseClick={this.closeRegistrationLayer}
                        ariaLabelledBy="registerLayerTitle"
                        htmlAttrs={{"aria-describedby": "registerLayerDescription"}}
                    >
                        <div className="four-part-page__registration-modal">
                            <Headline size="h2" as="h2" id="registerLayerTitle">Register now!</Headline>
                            <Paragraph id="registerLayerDescription">Choose your registration path.</Paragraph>
                            <div className="four-part-page__registration-actions">
                                <Button href={employeesRegistrationUrl} htmlAttrs={{ target: "_blank", rel: "noopener noreferrer" }}>
                                    Commerzbank Employees
                                </Button>
                                <Button onClick={this.openPartnerSubmenu}>
                                    Partners of TechConnect 2026
                                </Button>
                            </div>

                            {this.state.showPartnerSubmenu && (
                                <div className="four-part-page__registration-submenu">
                                    <label className="four-part-page__registration-label" htmlFor="partner-company">Company</label>
                                    <select
                                        id="partner-company"
                                        className="four-part-page__registration-field"
                                        value={this.state.partnerCompany}
                                        onChange={this.handlePartnerCompanyChange}
                                    >
                                        <option value="">Choose company</option>
                                        {partnerCompanies.map((company) => (
                                            <option key={company} value={company}>{company}</option>
                                        ))}
                                    </select>

                                    <label className="four-part-page__registration-label" htmlFor="partner-email">E-mail</label>
                                    <input
                                        id="partner-email"
                                        className="four-part-page__registration-field"
                                        type="email"
                                        value={this.state.partnerEmail}
                                        onChange={this.handlePartnerEmailChange}
                                        placeholder="name@company.com"
                                    />

                                    <label className="four-part-page__registration-label" htmlFor="partner-password">Password</label>
                                    <input
                                        id="partner-password"
                                        className="four-part-page__registration-field"
                                        type="text"
                                        value={this.state.partnerPassword}
                                        onChange={this.handlePartnerPasswordChange}
                                        placeholder="Enter password"
                                    />

                                    {this.state.partnerFormError && (
                                        <Paragraph className="four-part-page__registration-error">{this.state.partnerFormError}</Paragraph>
                                    )}

                                    <Button onClick={this.submitPartnerRegistration}>Register</Button>
                                </div>
                            )}
                        </div>
                    </Layer>
                    <Theme look={Theme.Dark} className="elevated-section-theme">
                        <Section className="elevated-section">
                            <Grid>
                                <Grid.Row>
                                    <Grid.Column size={1}></Grid.Column>
                                    <Grid.Column size={10} horizontalAlign={Grid.HorizontalAlign.CENTER}>
                                        <Video src="../techconnect2025.mp4"
                                                poster="../techconnect2025.png"
                                                videoTitle={"TechConnect 2025"}/>
                                    </Grid.Column>
                                    <Grid.Column size={1}></Grid.Column>
                                </Grid.Row>
                            </Grid>
                        </Section>
                    </Theme>
                    <Section id="agenda">
                        <Headline size="h1" as="h1" id="headline_agenda">Agenda</Headline>
                        <div className="agenda-table agenda-table--desktop" role="list">
                            <div className="agenda-table__header" aria-hidden="true">
                                <Headline size="h2" as="h2" id="headline_agenda_1">Stage 1</Headline>
                                <Headline size="h2" as="h2" id="headline_agenda_2">Stage 2</Headline>
                            </div>
                            {agendaRows.map((row, rowIndex) => (
                                <div
                                    key={`agenda-row-${row.time}-${rowIndex}`}
                                    className={`agenda-table__row${rowIndex % 2 === 1 ? " agenda-table__row--alt" : ""}`}
                                    role="listitem"
                                >
                                    {row.isFullWidth || this.isSharedBreakRow(row) ? (
                                        <div className="agenda-table__cell agenda-table__cell--full">
                                            {renderAgendaItem("All stages", row.stage1Item || row.stage2Item, rowIndex, " agenda-stage-label--shared")}
                                        </div>
                                    ) : (
                                        <>
                                            <div className="agenda-table__cell agenda-table__cell--stage1">
                                                {renderAgendaItem("Stage 1", row.stage1Item, rowIndex)}
                                            </div>
                                            <div className="agenda-table__cell agenda-table__cell--stage2">
                                                {renderAgendaItem("Stage 2", row.stage2Item, rowIndex)}
                                            </div>
                                        </>
                                    )}
                                </div>
                            ))}
                        </div>
                        <div className="agenda-table-mobile" role="list">
                            <Headline size="h2" as="h2">Stage 1</Headline>
                            {stage1Agenda.map((item, index) => (
                                <div
                                    key={`agenda-mobile-stage1-${item.time}-${index}`}
                                    className={`agenda-table-mobile__row${index % 2 === 1 ? " agenda-table-mobile__row--alt" : ""}`}
                                    role="listitem"
                                >
                                    {renderAgendaItem("Stage 1", item, index)}
                                </div>
                            ))}
                            <Headline size="h2" as="h2">Stage 2</Headline>
                            {stage2Agenda.map((item, index) => (
                                <div
                                    key={`agenda-mobile-stage2-${item.time}-${index}`}
                                    className={`agenda-table-mobile__row${index % 2 === 1 ? " agenda-table-mobile__row--alt" : ""}`}
                                    role="listitem"
                                >
                                    {renderAgendaItem("Stage 2", item, index)}
                                </div>
                            ))}
                        </div>
                    </Section>
                    <Layer
                        closeLinkLabel={"Close"}
                        returnFocus={true}
                        open={this.state.isAgendaLayerOpen}
                        onCloseClick={this.closeAgendaLayer}
                        ariaLabelledBy="agendaLayerTitle"
                        htmlAttrs={{"aria-describedby": "agendaLayerDescription"}}
                    >
                        <div className="four-part-page__agenda-layer-content">
                            {selectedAgendaItem && (
                                <>
                                    <Headline size="h2" as="h2" id="agendaLayerTitle">{`${selectedAgendaItem.stage}`}</Headline>
                                    <Headline size="h2" as="h2" id="agendaLayerTitle">{`${selectedAgendaItem.time}`}</Headline>
                                    <Headline size="h2" as="h2" id="agendaLayerTitle">{`${selectedAgendaItem.title}`}</Headline>
                                    {selectedAgendaDetails && (
                                        <>
                                            {selectedAgendaDetails.speakers.length > 0 && (
                                                <>
                                                    <Headline size="h5" as="h5" id="agendaLayerDescription">Speakers:</Headline>
                                                    <Paragraph>{selectedAgendaDetails.speakers.join(", ")}</Paragraph>
                                                </>
                                            )}
                                            {selectedAgendaDetails.moderator && (
                                                <>
                                                    <Headline
                                                        size="h5"
                                                        as="h5"
                                                        id={selectedAgendaDetails.speakers.length > 0 ? undefined : "agendaLayerDescription"}
                                                    >
                                                        Moderator:
                                                    </Headline>
                                                    <Paragraph>{selectedAgendaDetails.moderator}</Paragraph>
                                                </>
                                            )}
                                        </>
                                    )}
                                    {!selectedAgendaDetails && (
                                        <Paragraph id="agendaLayerDescription">No additional speaker details provided.</Paragraph>
                                    )}
                                    <Paragraph>{selectedAgendaItem.abstract}</Paragraph>
                                </>
                            )}
                        </div>
                    </Layer>
                    <Section id="section-2">
                        <Headline size="h1" as="h1" id="headline_speakers">Speakers</Headline>
                        <Grid>
                            <Grid.Row>
                                {visibleSpeakers.map((member) => (
                                    <Grid.Column size={4} horizontalAlign={Grid.HorizontalAlign.CENTER} key={member.imageSrc || member.name}>
                                        <PersonCard
                                            name={member.name}
                                            position={member.position}
                                            imageSrc={member.imageSrc}
                                            imageAlt={member.name}
                                            layerContent={member.layerContent}
                                        />
                                    </Grid.Column>
                                ))}
                            </Grid.Row>
                            {tcSpeakers.length > 6 && (
                                <Grid.Row>
                                    <Grid.Column size={12} horizontalAlign={Grid.HorizontalAlign.CENTER}>
                                        <Button onClick={this.toggleSpeakersVisibility}>
                                            {this.state.showAllSpeakers ? "See less" : "See all"}
                                        </Button>
                                    </Grid.Column>
                                </Grid.Row>
                            )}
                        </Grid>
                    </Section>
                    <Section className="elevated-section" id="section-3">
                        <Grid>
                            <Grid.Row>
                                <Grid.Column size={6}>
                                    <Headline size="h1" as="h1" id="headline_partners">Partners</Headline>
                                </Grid.Column>
                            </Grid.Row>
                            <Grid.Row verticalAlign="middle">
                                {partnerLogos.map((logoFileName) => (
                                    <Grid.Column size={2} key={logoFileName}>
                                        <Picture className="elevated-image" imgSrc={`../tc_partners_logos/${logoFileName}`}/>
                                    </Grid.Column>
                                ))}
                            </Grid.Row>
                        </Grid>
                    </Section>
                    <Section id="section-4">
                        <Headline size="h1" as="h1" id="headline_s3">2025 Throwback</Headline>
                        <GallerySlider
                            className="perspective-slider"
                            appearance="card"
                            ariaRoleDescription="Slider"
                            ariaLabelledBy="headline_s3"
                        >
                                <GallerySlider.Item
                                    key={2}
                                    pictureImgSrc="../kasia_welpa.jpg"
                                    >
                                <div className="perspective-card-content">
                                    <div className="perspective-card-text">
                                        <Paragraph>
                                            "The discussion 'People vs AI: What will drive competitiveness in the finance and banking sector?' was dynamic and inspiring, offering unique perspectives on critical topics."
                                        </Paragraph>
                                    </div>
                                    <div className="perspective-card-action">
                                        <Button onClick={this.toggleDrawer2}
                                                htmlAttrs={{"aria-haspopup": "dialog",}}
                                        >More here</Button>
                                    </div>
                                </div>
                            </GallerySlider.Item>
                            <GallerySlider.Item
                                key={3}
                                pictureImgSrc="../random1.png"
                            >
                                <div className="perspective-card-content">
                                    <div className="perspective-card-text">
                                        <Paragraph>
                                            "The TechConnect Conference 2025 highlighted the importance of cross-industry dialogue in understanding the opportunities and risks of innovation, with dynamic discussions on artificial intelligence."
                                        </Paragraph>
                                    </div>
                                    <div className="perspective-card-action">
                                        <Button onClick={this.toggleDrawer3}
                                                htmlAttrs={{"aria-haspopup": "dialog",}}
                                        >More here</Button>
                                    </div>
                                </div>
                            </GallerySlider.Item>
                            <GallerySlider.Item
                                key={1}
                                pictureImgSrc="../random2.jpg"
                            >
                                <div className="perspective-card-content">
                                    <div className="perspective-card-text">
                                        <Paragraph>
                                            "TechConnect 2025 was filled with inspiring presentations and a truly engaged audience that made every discussion a pleasure to be part of."
                                        </Paragraph>
                                    </div>
                                    <div className="perspective-card-action">
                                        <Button onClick={this.toggleDrawer4}
                                                htmlAttrs={{"aria-haspopup": "dialog",}}
                                        >More here</Button>
                                    </div>
                                </div>
                            </GallerySlider.Item>
                            <GallerySlider.Item
                                key={4}
                                pictureImgSrc="../OlaPirek.png"
                            >
                                <div className="perspective-card-content">
                                    <div className="perspective-card-text">
                                        <Paragraph>
                                            "The #TechConnect conference created a platform for knowledge sharing, professional growth, and networking across various roles, from attendees and moderators to speakers and organizers."
                                        </Paragraph>
                                    </div>
                                    <div className="perspective-card-action">
                                        <Button onClick={this.toggleDrawer1}
                                                htmlAttrs={{"aria-haspopup": "dialog",}}
                                        >More here</Button>
                                    </div>
                                </div>
                            </GallerySlider.Item>
                        </GallerySlider>
                        <Layer
                            closeLinkLabel={"Get back"}
                            returnFocus={true}
                            open={this.state.open1}
                            onCloseClick={this.toggleDrawer1}
                            ariaLabelledBy="layerLeftLabel"
                            htmlAttrs={{ "aria-describedby": "layerLeftDescription", }}>
                            <Paragraph id="layerLeftDescription">
                                {this.formatText(this.state.pageData.part3Text)}
                            </Paragraph>
                            <Paragraph>Aleksandra Pirek, Chapter LEad at Commerzbank, co-organiser TechConnect 2025</Paragraph>
                        </Layer>
                        <Layer
                            closeLinkLabel={"Get back"}
                            returnFocus={true}
                            open={this.state.open2}
                            onCloseClick={this.toggleDrawer2}
                            ariaLabelledBy="layerLeftLabel"
                            htmlAttrs={{ "aria-describedby": "layerLeftDescription", }}>
                            <Paragraph id="layerLeftDescription">
                                Being a panel moderator at the TechConnect 2025 Conference was an unforgettable experience. The discussion "People vs AI: What will drive competitiveness in the finance and banking sector?" was dynamic and inspiring, giving me the chance to engage with leaders and witness unique perspectives on critical topics. Watching ideas bounce around the room left me buzzing with energy.

                                The panel discussions turned out to be one of the event’s biggest highlights. Initially tucked away in smaller rooms, they proved incredibly popular with attendees, thanks to their relaxed, conversational vibe. The format allowed for a transformative exchange of ideas—less formal, more coffee-chat style—and the audience connected deeply with it.

                                TechConnect reminded me that impactful events thrive not just on what’s shared, but how it’s shared. The blend of informality and innovation created a space where real connections flourished. I can’t wait for the surprises and spirited exchanges the 2026 edition will surely bring!
                            </Paragraph>
                            <Paragraph>Katarzyna Wełpa-Zajączkowska, Scrum Master at Commerzbank</Paragraph>
                        </Layer>
                        <Layer
                            closeLinkLabel={"Get back"}
                            returnFocus={true}
                            open={this.state.open3}
                            onCloseClick={this.toggleDrawer3}
                            ariaLabelledBy="layerLeftLabel"
                            htmlAttrs={{ "aria-describedby": "layerLeftDescription", }}>
                            <Paragraph id="layerLeftDescription">
                                The TechConnect Conference 2025 was an extraordinary event that not only focused on technological progress but also fostered exchange within an engaged community. The dynamic venue at the Alchemium building of the Technical University of Łódź provided the perfect setting for over 500 participants – from Commerzbank employees to experts from leading technology companies such as Google and Red Hat.

                                As a participant, I was impressed by the inspiring presentations and discussions that highlighted topics like artificial intelligence and cybersecurity. What fascinated me the most was the diversity of perspectives – from practical applications to debates on ethical and cultural challenges posed by modern technologies. The panels and presentations, including case studies and forward-looking approaches, offered valuable insights into the technological landscape.

                                The conference emphasized the importance of cross-industry dialogue in understanding the opportunities and risks of innovation. The atmosphere was defined by collaboration and inspiration – a clear indication that Commerzbank plays a key role in shaping the technological future.

                                I left the TechConnect Conference feeling energized and confident. It was not just an event but a platform paving the way for an exciting technological future.
                            </Paragraph>
                            <Paragraph>Roman Balkow, Senior Business Specialist at Commerzbank</Paragraph>
                        </Layer>
                        <Layer
                            closeLinkLabel={"Get back"}
                            returnFocus={true}

                            open={this.state.open4}
                            onCloseClick={this.toggleDrawer4}
                            ariaLabelledBy="layerLeftLabel"
                            htmlAttrs={{ "aria-describedby": "layerLeftDescription", }}>
                            <Paragraph id="layerLeftDescription">
                                Last year, I had the honor of speaking on the stage at TechConnect 2025.
                                The conference, organized by Commerzbank, was an event full of substantive and inspiring presentations. The truly engaged audience, actively participating in the discussions, made it an absolute pleasure. I also found a fantastic atmosphere and many opportunities for interesting conversations offstage. Special recognition is due to the organizers, who showed great dedication in ensuring a positive and motivating energy throughout. I highly recommend it to anyone still undecided!
                            </Paragraph>
                            <Paragraph>Beata Janiak, Pentester at Idemia</Paragraph>
                        </Layer>
                        {/*<Grid.Row  >*/}
                        {/*    <Grid.Column size={6}>*/}
                        {/*        <H2>{this.state.pageData.part3Title}</H2>*/}
                        {/*    </Grid.Column>*/}
                        {/*</Grid.Row>*/}
                        {/*<Grid.Row>*/}
                        {/*    <Grid.Column size={9}>*/}
                        {/*        <Paragraph>*/}
                        {/*            {this.formatText(this.state.pageData.part3Text)}*/}
                        {/*        </Paragraph>*/}
                        {/*    </Grid.Column>*/}
                        {/*    <Grid.Column size={3}>*/}
                        {/*        <Picture imgSrc={this.state.pageData.part3Image.absoluteLink}/>*/}
                        {/*    </Grid.Column>*/}
                        {/*</Grid.Row>*/}
                    </Section>


                    <Section id="section-5">
                        <Headline size="h1" as="h1" id="headline_team">TechConnect Team</Headline>
                        <Grid>
                            <Grid.Row>
                                {tcTeam.map((member) => (
                                    <Grid.Column size={2} horizontalAlign={Grid.HorizontalAlign.CENTER} key={member.imageSrc || member.name}>
                                        <PersonCard
                                            name={member.name}
                                            position={member.position}
                                            url={member.url}
                                            imageSrc={member.imageSrc}
                                            imageAlt={member.name}
                                            showPosition={false}
                                            showEducation={false}
                                        />
                                    </Grid.Column>
                                ))}
                            </Grid.Row>
                            <Grid.Row>
                                <Grid.Column size={12}>
                                    <Paragraph>We are always open to new conversations, inspiring collaborations, and questions. Contact us at <Link href="mailto:innovativeminds@commerzbank.com">innovativeminds@commerzbank.com</Link>
                                    </Paragraph>
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                    </Section>
                </div>
            );
        }
        return (
            <Section className="page-loader">
                <Grid>
                    <Grid.Row>
                        <Grid.Column size={12} horizontalAlign={Grid.HorizontalAlign.CENTER}>
                            <Spinner/>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </Section>

        );

    }
}

// export default NewsPage
function mapStateToProps(state) {
    return {lang: state.lang}
}

export default connect(mapStateToProps)(FourPartPage)
